
import { Col,  Row, Space, Typography } from "antd";
import FavoriteList from "./Components/FavoriteList";
import { useGetSavedSearchs } from "./ServerSideStates";
import PageTitle from "apps/Common/PageTitle";



const FavoriteSearchsIndex = () => {
  const { Text } = Typography;
  const favoriteFilters = useGetSavedSearchs()

  return (
    <>
      <Col xs={24}>
        <Row gutter={[10, 20]} className="">
        {/* <Col span={24} className="!flex justify-center">
        <PageTitle
        
        title="Kaydedilen Aramalar"
        count={favoriteFilters?.data?.data?.length || 0}
        />
           
          </Col> */}
         
          <Col xs={24} >
              <FavoriteList/>
          </Col>
        </Row>
      </Col>
     
    </>
  );
};

export default FavoriteSearchsIndex;
